// extracted by mini-css-extract-plugin
export default {"container":"DataTransfer_container__g5maF","body":"DataTransfer_body__xzKJz"};